export default __webpack_public_path__ + "static/media/React_-_adamr.space___Codecademy.b2ff09be.pdf";